/**
 * @param {unknown} value
 * @returns {string}
 */
function normalizeText(value) {
  return String(value ?? '').trim();
}

/**
 * @param {unknown} option
 * @param {(option: unknown) => string} getOptionLabel
 * @returns {string}
 */
export function resolveAutocompleteOptionLabel(option, getOptionLabel) {
  if (typeof getOptionLabel === 'function') {
    return normalizeText(getOptionLabel(option));
  }
  return '';
}

/**
 * @param {unknown} option
 * @param {(option: unknown) => string} getOptionSubtitle
 * @returns {string}
 */
export function resolveAutocompleteOptionSubtitle(option, getOptionSubtitle) {
  if (typeof getOptionSubtitle === 'function') {
    return normalizeText(getOptionSubtitle(option));
  }
  return '';
}

/**
 * @param {unknown[]} items
 * @param {string} query
 * @param {(option: unknown) => string} getOptionLabel
 * @param {(option: unknown) => string} getOptionSubtitle
 * @returns {unknown[]}
 */
export function filterAutocompleteOptions(items, query, getOptionLabel, getOptionSubtitle) {
  const term = normalizeText(query).toLowerCase();
  if (!term) return items;

  return items.filter((item) => {
    const label = resolveAutocompleteOptionLabel(item, getOptionLabel).toLowerCase();
    const subtitle = resolveAutocompleteOptionSubtitle(item, getOptionSubtitle).toLowerCase();
    return label.includes(term) || subtitle.includes(term);
  });
}
